import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ViewProductLayer from "../components/ViewProductLayer";


const ViewProductPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="View Products" />

        {/* CardLayer */}
        <ViewProductLayer />


      </MasterLayout>
    </>
  );
};

export default ViewProductPage;
